import { z } from 'zod';
export const selfAssessmentCommandSchema = z.object({
    expectedGameVersion: z.number().int().nonnegative(),
    score: z.number().int().min(-5).max(5),
    whatMatteredMost: z.string().min(1).max(2000),
});
export const selfAssessmentViewSchema = z.object({
    teamId: z.string(),
    desiredFuture: z.string(),
    score: z.number().int().min(-5).max(5),
    whatMatteredMost: z.string(),
    submittedAt: z.string().datetime(),
});
export const finalRecapContentSchema = z.object({
    openingState: z.string().min(1).max(5000),
    finalState: z.string().min(1).max(5000),
    headlines: z.array(z.string().max(500)).min(3).max(5),
    keyChanges: z.array(z.string().max(1000)).max(12),
    turningPoints: z.array(z.string().max(1000)).max(12),
    organizationArcs: z.array(z.string().max(1500)).max(12),
    collaborationsAndConflicts: z.array(z.string().max(1000)).max(12).optional(),
    recordsAndFirsts: z.array(z.string().max(1000)).max(12).optional(),
    unresolvedRisks: z.array(z.string().max(1000)).max(12),
    selectedShoutOuts: z.array(z.string().max(500)).max(8).optional(),
});
export const finalRecapCommandSchema = z.object({
    expectedGameVersion: z.number().int().nonnegative(),
    action: z.enum(['SAVE_DRAFT', 'APPROVE_AND_COMPLETE']),
    content: finalRecapContentSchema,
});
export const finalRecapViewSchema = z.object({
    id: z.string(),
    status: z.enum(['DRAFT', 'APPROVED']),
    historyVersion: z.number().int().nonnegative(),
    content: finalRecapContentSchema,
});
export const correctionCommandSchema = z.object({
    expectedGameVersion: z.number().int().nonnegative(),
    originalResolutionId: z.string(),
    originalBroadcastId: z.string(),
    reason: z.string().min(1).max(2000),
    correctedState: z.record(z.string(), z.unknown()),
});
export const correctionViewSchema = z.object({
    id: z.string(),
    originalResolutionId: z.string(),
    originalBroadcastId: z.string(),
    reason: z.string(),
    correctedStateVersion: z.number().int().nonnegative(),
    createdAt: z.string().datetime(),
    moderatorAction: z.literal('CORRECTION_PUBLISHED'),
});
//# sourceMappingURL=closing.js.map